import {
    actionCreator,
    API_URL,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    jsonApiHeader,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage,
  } from '../../../../../../../actions/utilAction';
  
  export { 
    jsonApiHeader, 
    showWarningMessage, 
    showErrorMessage, 
    actionCreator, 
    checkHttpStatus, 
    create_post_data, 
    createSearchUrl, 
    showSuccessMessage 
  };
  
  export const POST_ANTECEDENT_API = `${API_URL}/api/PatientAntecedentsReduction/SavePatientAntecedentsReduction`;
  export const GET_ANTECEDENT_LIST_API = `${API_URL}/api/PatientAntecedentsReduction/GetPatientAntecedentsReduction`;
  export const GET_ANTECEDENT_DETAIL_API = `${API_URL}/api/PatientAntecedentsReduction/GetPatientAntecedentsReductionById`;
  export const DELETE_ANTECEDENT_API = `${API_URL}/api/PatientAntecedentsReduction/DeletePatientAntecedentsReduction`;
  export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
  
  export const antecedentActionTypes = {
    get_masterData: createRequestActionTypes('GET_MASTERDATA'),
    save_antecedent: createRequestActionTypes('SAVE_ANTECEDENT'),
    get_antecedentList: createRequestActionTypes('GET_ANTECEDENTLIST'),
    get_antecedentDetail: createRequestActionTypes('GET_ANTECEDENTDETAIL'),
    delete_antecedent: createRequestActionTypes('DELETE_ANTECEDENT'),
  };
  
  export const MODULE = 'DCMASTER_ANTECEDENTSREDUCTION';


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/Antecedents/constants/ApiConstants.js